class ModifierItem {
  constructor(sourceModifier, cartItem) {
    return {
      productId: cartItem.item.id,
      quantity: cartItem.quantity,
      cost: +sourceModifier.cost,
      id: Number(sourceModifier.modifierId),
      originalCost: +sourceModifier.cost,
      status: sourceModifier.status,
      inventoryAmount: sourceModifier.inventoryAmount,
      soldOut: sourceModifier.soldOut,
      name: sourceModifier.name,
      needIcon: sourceModifier.needIcon
    };
  }
}

export default ModifierItem;
